
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["font-color",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.35 20.69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Vrstva_2","data-name":"Vrstva 2"}},[_c('path',{attrs:{"d":"M8.46 3.44h1.89V.15A23 23 0 007.59 0C4.87 0 3 1.71 3 4.86v2.9H0v3.68h3v9.25h3.69v-9.25h2.88L10 7.76H6.69V5.23c0-1.07.29-1.79 1.77-1.79z","id":"Vrstva_1-2","data-name":"Vrstva 1"}})])])
          )
        }
      }
    